/*
 * Copyright (c) 2018 Integral Agile, Inc. All rights reserved.
 *   Use of this file is subject to the terms and conditions defined in the file
 * 'LICENSE.txt'
 *   which is distributed in the root directory of this source code tree.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import EditInput from './editInput';
import {
  createCriteria,
  updateCriteria,
  deleteCriteria,
  fetchTeamCriteria
} from '../../actions/criteriaActions';
import {
  currentTeamCriteria,
  orgLevelsForCriteria
} from '../../selectors/criteriaSelector';

class ManageCriteria extends React.Component {
  constructor(props) {
    super(props);
    this.state = { acInput: '', edit: '', editInput: '' };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleEdit = this.handleEdit.bind(this);
    this.handleSubmitEdit = this.handleSubmitEdit.bind(this);
  }

  componentWillMount() {
    if (this.props.teamId && this.props.type)
      this.props.fetchTeamCriteria(this.props.teamId, this.props.type);
  }

  componentDidMount() {
    const { organizationLevels } = this.props;

    const defaultOrganizationLevel =
      organizationLevels.length > 0
        ? organizationLevels.find((level) => level.default_level) ||
          organizationLevels[0]
        : {};

    const inputType = defaultOrganizationLevel.name || '';
    this.props.handleEditInputType(inputType);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.teamId !== nextProps.teamId)
      this.props.fetchTeamCriteria(nextProps.teamId, this.props.type);
  }

  handleChange(event) {
    this.setState({ [event.target.name]: event.target.value });
  }

  handleSubmit(event) {
    event.preventDefault();
    const { type } = this.props;
    const payload = {
      type,
      criterion: {
        short_name: this.state.acInput,
        item_type: this.props.acInputType,
        team_id: this.props.teamId
      }
    };
    if (payload.criterion.short_name.length > 0) {
      this.clearEditFields();
      return this.props.createCriteria(payload, type);
    }
    return null;
  }

  handleSubmitEdit = () => {
    const { type } = this.props;
    const payload = {
      type,
      criterion: {
        short_name: this.state.editInput,
        item_type: this.state.acInputType,
        team_id: this.props.teamId
      }
    };
    if (payload.criterion.short_name.length > 0) {
      const editId = this.state.edit;
      this.clearEditFields();
      return this.props.updateCriteria(editId, payload, type);
    }
    return null;
  };

  handleEdit(criterium) {
    this.setState({
      edit: criterium.id,
      editInput: criterium.short_name
    });
  }

  clearEditFields = () => {
    this.setState({ edit: '', editInput: '', acInput: '' });
  };

  handleDelete = (criterium) => {
    const { type, deleteCriteria } = this.props;
    deleteCriteria(criterium, type);

    // posts message to app.jsx event listener
    window.postMessage({ type: 'criteria', action: 'delete', filter: type });
  };

  render() {
    const { criteria, isFetching } = this.props;
    const allowEdit = !isFetching;
    const allowCreate = !isFetching;
    const allowDelete = !isFetching;

    return (
      <div className="manage-criteria">
        <div className="criteria-list">
          {criteria.map((criterium) => (
            <div className="criteria-row" key={criterium.id}>
              <button
                type="button"
                className="btn"
                onClick={() => this.handleDelete(criterium)}
                disabled={!allowDelete}
              >
                <span className="glyphicon glyphicon-minus red" />
              </button>
              {this.state.edit !== criterium.id && (
                <button
                  type="button"
                  className="btn"
                  onClick={() => {
                    this.handleEdit(criterium);
                  }}
                  disabled={!allowEdit}
                >
                  <span className="glyphicon glyphicon-pencil" />
                </button>
              )}
              {this.state.edit === criterium.id ? (
                <EditInput
                  handleChange={this.handleChange}
                  editInput={this.state.editInput}
                  handleSubmitEdit={this.handleSubmitEdit}
                  clearEditFields={this.clearEditFields}
                  criterium={criterium}
                />
              ) : (
                <span
                  className={`criteria-name ${
                    criterium.fulfilled && 'fulfilled'
                  }`}
                  onDoubleClick={() => {
                    this.handleEdit(criterium);
                  }}
                >
                  {criterium.short_name} ({criterium.item_type})
                </span>
              )}
            </div>
          ))}
        </div>
        <form
          className="form-inline acceptance-criteria-input"
          onSubmit={this.handleSubmit}
        >
          <span className="input-with-loading">
            <input
              disabled={isFetching}
              value={this.state.acInput}
              onChange={this.handleChange}
              name="acInput"
            />
            {isFetching && <div id="add-story-mini-loader" />}
          </span>
          <button
            type="submit"
            className="btn add-ac button-lavender strong"
            disabled={!allowEdit}
          >
            ADD
          </button>
        </form>
      </div>
    );
  }
}

ManageCriteria.propTypes = {
  teamId: PropTypes.number.isRequired,
  type: PropTypes.string.isRequired,
  criteria: PropTypes.array,
  workPackage: PropTypes.object,
  createCriteria: PropTypes.func,
  updateCriteria: PropTypes.func,
  deleteCriteria: PropTypes.func,
  fetchCriteria: PropTypes.func
};

const mapStateToProps = (state, ownProps) => {
  const criteria = currentTeamCriteria(state, ownProps);
  const organizationLevels = orgLevelsForCriteria(state);

  return {
    organizationLevels,
    criteria,
    isFetching: state.criteriaReducer.isFetching
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      createCriteria,
      updateCriteria,
      deleteCriteria,
      fetchTeamCriteria
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(ManageCriteria);
